import { render } from "./OrganizationsTable.vue?vue&type=template&id=7842c8f7"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__